<div class="main-content-container">
  <div class="main-container-body">
    <div class="page-title-container d-flex">
      <div class="page-title flex-grow-1">
        <div _ngcontent-rvc-c80="" class="mb-0">
          <div _ngcontent-rvc-c80="" class="d-flex align-items-center">
            <div _ngcontent-rvc-c80="" class="pl-2 pr-2">
              <a href="javascript:void(0)" class="d-inline-flex" (click)="backToBotApplication()"><img
              src="assets/images/grid-back.png"></a>
            </div>
            <div> Launch Bot </div>
          </div>
        </div>
      </div>
    </div>
    <div class="chat_window">
      <div class="top_menu">
        <!-- <div class="buttons">
        <div class="button close"></div>
        <div class="button minimize"></div>
        <div class="button maximize"></div>
      </div> -->
      <div class="title">KareBot</div>
    </div>
    @if (messages.length > 0) {
      <ul class="messages">
        @for (message of messages; track message) {
                    <li class="message appeared" [ngClass]="{
                        left: message.author === 'bot',
                        right: message.author === 'user'
                      }">
            <div class="text_wrapper" [innerHTML]="message.content"></div>
          </li>
        }
      </ul>
    }

    <div class="bottom_wrapper clearfix">
      <div class="message_input_wrapper">
        <input [(ngModel)]="message" class="message_input" placeholder="Type your message here..." />
      </div>
      <div class="send_message">
                    <button class="aside-fixed-button primary-btn submitButton" style="padding: 10px 35px;
    margin-top: 5px;" (click)="send()">Send</button>
        <!-- <div class="icon"></div>
        <div class="text">Send</div> -->
      </div>
    </div>
  </div>
  <div class="message_template">
    <li class="message">
      <div class="avatar"></div>
      <div class="text_wrapper">
        <div class="text"></div>
      </div>
    </li>
  </div>
</div>
</div>